export default __webpack_public_path__ + "static/media/Warehouse-loadingbay-night.99504347.png";